// extracted by mini-css-extract-plugin
module.exports = {"switch":"AuthLanguageSwitch_switch__3sWUY","btn":"AuthLanguageSwitch_btn__2hnsI","btnActive":"AuthLanguageSwitch_btnActive__3XJOo"};